
import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";

interface QuizSignUpButtonProps {
  onClick: () => void;
}

const QuizSignUpButton = ({ onClick }: QuizSignUpButtonProps) => {
  return (
    <motion.div
      initial={{ y: 20, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ delay: 1.1, duration: 0.5 }}
      className="w-full max-w-md"
    >
      <Button
        onClick={onClick}
        className="bg-gradient-to-r from-corporate-secondary-100 to-corporate-secondary-75 hover:from-corporate-secondary-75 hover:to-corporate-secondary-100 text-corporate-neutral-100 p-6 text-lg w-full shadow-md transition-all duration-300 border-0"
      >
        <span>Sign Up for Free and go to Marketplace</span>
        <ArrowRight className="ml-2 w-5 h-5" />
      </Button>
    </motion.div>
  );
};

export default QuizSignUpButton;
